export const allRoutes = [
  "/",
  "/search",
  "/booking",
  "/payment",
  "/success",
  "/terms-and-conditions",
  "/privacy-policy",
  "/refund-policy",
  "/contact-us",
  "/reviews",
  "/about-us",
  "/faqs",
  "/gatwick-airport-parking",
  "/gatwick-airport-parking/gatwick-north-terminal-parking",
  "/gatwick-airport-parking/gatwick-south-terminal-parking",
  "/manchester-airport-parking",
  "/stansted-airport-parking",
  "/birmingham-airport-parking",
  "/heathrow-airport-parking",
  "/bristol-airport-parking",
  "/luton-airport-parking",
  "/liverpool-airport-parking",
  "/edinburgh-airport-parking",
  "/glasgow-airport-parking",
  "/belfast-city-airport-parking",
  "/belfast-international-airport",
  "/southampton-airport-parking",
  "/newcastle-airport-parking",
  "/southend-airport-parking",
  "/london-city-airport-parking",
  "/leeds-bradford-airport-parking",
  "/east-midlands-airport-parking",
  "/cardiff-airport-parking",
  "/aberdeen-airport-parking",
  "/meet-and-greet-parking",
  "/park-and-ride-parking",
  "/sitemap",
  // Company detail routes per airport
  "/gatwick-airport-parking/:companySlug",
  "/heathrow-airport-parking/:companySlug",
  "/manchester-airport-parking/:companySlug",
  "/stansted-airport-parking/:companySlug",
  "/birmingham-airport-parking/:companySlug",
  "/bristol-airport-parking/:companySlug",
  "/luton-airport-parking/:companySlug",
];
